/**
 * Component Entry
 *
 */

import Upload from './Upload'
export default Upload
export * from './Upload'
